import React from 'react';

export type FeatureFlags = Partial<{
  'HelloSign_Prep_Send_Early_Next': boolean
  'HelloSign_Rollout_Paginate_Signatures': boolean,
  'HelloSign_Request_Additional_Attachments': boolean,
  'HelloSign_Rollout_Live_Support': boolean,
  'HelloSign_Stars_20210727_Prep_Send_Template_Modal_Redesign': boolean,
  'HelloSign_Stars_20210811_Template_Page_Redesign_P2': boolean
  'HelloSign_Stars_20211006_Unified_JSON_Editor': boolean,
  'HelloSign_Yetis_20210930_Hide_Billing_Period_For_Yearly': boolean,
  'HelloSign_Stars_20211007_Template_Complete_Modal_Redesign': boolean,
  'HelloSign_Stars_20211020_Unified_JSON_Signer': boolean,
  'HelloSign_Yetis_20211014_Decoupled_Prep_And_Send_File_Uploader': boolean,
  'HelloSign_Stars_20211201_Unified_JSON_PrepAndSend': boolean,
  'HelloSign_Stars_20220120_update_team_share_modal': boolean,
  'HelloFax_Condors_20211215_Payment_Page': boolean,
  'HelloSign_Octopod_Hubspotv2_Integration': boolean,
  'showLeftNavWinkExperiment': string,
  'HelloSign_MantaRays_20220113_Rebrand_PurchaseExperience': boolean,
  'HelloSign_MantaRays_20220113_Rebrand_FirstUseExperience': boolean,
  'HelloSign_MantaRays_20220113_Rebrand_ContinuousUse': boolean,
  'HelloSign_MantaRays_20220113_Rebrand_SignerExperience': boolean,
  'HelloSign_MantaRays_20220113_Rebrand_AccountManagement': boolean,
  'HelloSign_MantaRays_20220113_Rebrand_GlobalExperience': boolean,
  'HelloSign_Frontend_Ops_20220322_Backdrop_Global_Branding_Experiment': boolean,
  'HelloSign_Frontend_Ops_20220322_Backdrop_Global_Components_Experiment': boolean,
  'HelloSign_Yetis_20220222_Documents_Query_Param_Filter': boolean,
  'HelloSign_Condors_20220303_Team_Success_Scope_1': boolean,
  'HelloSign_Yetis_20220323_Sig_Request_Success_Modals_On_Docs_Page': boolean
}>

const featureFlagContext = React.createContext<FeatureFlags | null>(null);
export const useRawFeatureFlagContext = () => React.useContext(featureFlagContext);

type ProviderProps = {
  featureFlags: FeatureFlags | null,
  children: React.ReactNode
}

export function FeatureFlagProvider({ featureFlags, children }: ProviderProps) {
  return (
    <featureFlagContext.Provider value={featureFlags}>
      {children}
    </featureFlagContext.Provider>
  );
}

/**
 *
 * @param name
 * @param fallback fallback value if we can't load the feature flag context for whatever reason
 * @returns
 */
export function useFeatureFlag(name: keyof FeatureFlags, fallback?: boolean) {
  const context = useRawFeatureFlagContext();

  if (!context) {
    if (fallback == null) {
      throw new Error('this needs to be rendered in a FeatureFlagProvider');
    }
    return fallback;
  }

  return Boolean(context[name]);
}

export function useVariationFeatureFlag(name: keyof FeatureFlags) {
  const context = useRawFeatureFlagContext();

  if (!context) {
    throw new Error('this needs to be rendered in a FeatureFlagProvider');
  }

  return String(context[name]);
}

type FeatureFlagProps = {
  name: keyof FeatureFlags,
  value?: boolean,
  children: JSX.Element,
  fallback?: boolean,
}
export function FeatureFlag({ name, children, value = true, fallback }: FeatureFlagProps):
  JSX.Element | null {
  const enabled = useFeatureFlag(name, fallback);

  if (enabled === value) {
    return children;
  }
  return null;
}
